import { ChapterWiseDataModel } from "./chapter-wise-model";

export class SectionWiseDataModal {
    id?:number;
    marks: number;
    note: string;
    noOfQns: number;
    mandatoryQns: number;
    eachQnWeightage: number;
    chapterWiseData: ChapterWiseDataModel[];
    languageWiseNote:any[]
    constructor(marks: number, note: string, noOfQns: number, mandatoryQns: number, eachQnWeightage: number, chapterWiseData: ChapterWiseDataModel[],languageWiseNote:any[]) {
        this.marks = marks;
        this.note = note;
        this.noOfQns = noOfQns;
        this.mandatoryQns = mandatoryQns;
        this.eachQnWeightage = eachQnWeightage;
        this.chapterWiseData = chapterWiseData;
        this.languageWiseNote = languageWiseNote;
    }
}